import gsap from 'gsap';
import React, { useCallback, useEffect, useRef } from 'react';
import styled from 'styled-components';
import { IconBase } from '../Base';
const Wrapper = styled.div `
  position: relative;
  display: table;
`;
const Lines = styled(IconBase) `
  position: relative;
  z-index: 1;

  path {
    &:last-child {
      stroke-dasharray: 6px;
      stroke-dashoffset: 12px;
    }
  }
`;
const Bottom = styled(IconBase) `
  position: absolute;
  inset: 0;
`;
const OverflowWrapper = styled.div `
  position: absolute;
  inset: 0 0 5px 0;
  overflow: hidden;
`;
const Back = styled(IconBase) ``;
const Front = styled(IconBase) `
  fill: var(--icon-background, ${({ theme }) => theme.background});
`;
export const IconDocument = ({ className, onDone, running }) => {
    const wrapperRef = useRef(null);
    const linesRef = useRef(null);
    const backRef = useRef(null);
    const frontRef = useRef(null);
    const triggerDone = useCallback(() => {
        if (onDone) {
            onDone();
        }
    }, [onDone]);
    useEffect(() => {
        if (running) {
            gsap.to([frontRef.current, linesRef.current], {
                keyframes: [
                    {
                        y: 3,
                        duration: 0.1,
                    },
                    {
                        y: -0.5,
                        duration: 0.2,
                    },
                    {
                        y: 0,
                        duration: 0.3,
                        onComplete: () => {
                            triggerDone();
                        },
                    },
                ],
            });
            gsap.to(backRef.current, {
                keyframes: [
                    {
                        y: -3,
                        duration: 0.1,
                    },
                    {
                        y: 0.5,
                        duration: 0.2,
                    },
                    {
                        y: 0,
                        duration: 0.3,
                    },
                ],
            });
        }
    }, [running]);
    return (React.createElement(Wrapper, { className: className, ref: wrapperRef },
        React.createElement(OverflowWrapper, null,
            React.createElement(Back, { ref: backRef },
                React.createElement("g", { strokeWidth: "1.5", style: { stroke: 'var(--icon-color)' } },
                    React.createElement("path", { d: "M2.5 18V7.16667C2.5 6.72464 2.67559 6.30072 2.98816 5.98816C3.30072 5.67559 3.72464 5.5 4.16667 5.5H12.5C12.942 5.5 13.366 5.67559 13.6785 5.98816C13.9911 6.30072 14.1667 6.72464 14.1667 7.16667V18" })))),
        React.createElement(OverflowWrapper, null,
            React.createElement(Front, { ref: frontRef },
                React.createElement("g", { strokeWidth: "1.5", style: { stroke: 'var(--icon-color)' } },
                    React.createElement("path", { d: "M5.83331 17V4.16667C5.83331 3.72464 6.00891 3.30072 6.32147 2.98816C6.63403 2.67559 7.05795 2.5 7.49998 2.5H15.8333C16.2753 2.5 16.6993 2.67559 17.0118 2.98816C17.3244 3.30072 17.5 3.72464 17.5 4.16667V17" })))),
        React.createElement(Bottom, null,
            React.createElement("g", { strokeWidth: "1.5", style: { stroke: 'var(--icon-color)' } },
                React.createElement("path", { d: "M4.16667 17.5H15.8333C16.2754 17.5 16.6993 17.3244 17.0118 17.0118C17.3244 16.6993 17.5 16.2754 17.5 15.8333V15M4.16667 17.5C4.60869 17.5 5.03262 17.3244 5.34518 17.0118C5.65774 16.6993 5.83333 16.2754 5.83333 15.8333V15M4.16667 17.5C3.72464 17.5 3.30072 17.3244 2.98816 17.0118C2.67559 16.6993 2.5 16.2754 2.5 15.8333V15" }))),
        React.createElement(Lines, { ref: linesRef },
            React.createElement("g", { strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round", style: { stroke: 'var(--icon-color)' } },
                React.createElement("path", { d: "M8.75 5.83333H14.5833" }),
                React.createElement("path", { d: "M8.75 9.16667H14.5833" }),
                React.createElement("path", { d: "M8.75 12.5H14.5833" })))));
};
//# sourceMappingURL=Document.js.map